import React from "react";
import ListItem from "../../core/design-system/ListItem/ListItem";

interface RecentTsnsProps {
  recentTransactionsList: any[];
}

const RecentTransactions: React.FC<RecentTsnsProps> = (props) => {
  const usersProfilePhotos = [
    "14.jpg",
    "17.jpg",
    "20.jpg",
    "51.jpg",
    "65.jpg",
    "94.jpg",
    "1.jpg",
    "67.jpg",
    "74.jpg",
  ];
  const nameProvider = (data: any) => {
    if (data.type === "OWN_ACCOUNT_TRANSFER") {
      return data.customerName;
    } else if (!!data.beneficiaryName) {
      return data.beneficiaryName;
    }
    return "";
  };
  return (
    <div className="flex flex-col bg-gray p-3 rounded-xl w-full border border-lightGray bg-gray-100_01 h-full">
      <div className="flex flex-col gap-6 bg-white p-3 rounded-lg bg-white-A700 flex-[1]">
        <div className="flex flex-row justify-between">
          <p className="text-lg xs:font-medium 4xl:font-normal">
            Recent Transactions
          </p>
          <p className="text-md font-medium hover:cursor-pointer text-primaryText">
            View all
          </p>
        </div>

        <div className="flex flex-col gap-2">
          {props?.recentTransactionsList &&
          props.recentTransactionsList.length > 0 ? (
            props.recentTransactionsList.map((item, index) => (
              <ListItem
                profilePhoto={usersProfilePhotos[index]}
                key={item.id}
                name={nameProvider(item)}
                date={
                  !!item.transactionDate
                    ? item.transactionDate
                    : `${index + 1}/4/24`
                }
                amount={item.amount}
              />
            ))
          ) : (
            <p>No recent transactions found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentTransactions;
